// extracted by mini-css-extract-plugin
export default {"component":"VrmInputVRM__component-t7Pm","input":"VrmInputVRM__input-tcBS","error":"VrmInputVRM__error-IEJR"};